import Link from 'next/link';
import styles from './styles.module.scss';

const Job = props => {
    const {job} = props || {};
    const {name,  department, location, id} = job || {};
    console.log(location);
    return(
        <div className={styles.job}>
            <div className={`${styles.job__col} ${styles.job__titleBox} ${styles.job__half}`}>
                <p className={styles.job__title}>
                    {name}
                </p>
                <Link href={`https://www.smartrecruiters.com/Daxko1/${id}`} target={'_blank'} className={styles.job__apply}>
                    Apply
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99935 2.66663L7.05935 3.60663L10.7793 7.33329H2.66602V8.66663H10.7793L7.05935 12.3933L7.99935 13.3333L13.3327 7.99996L7.99935 2.66663Z" fill="#E8236B"/>
                    </svg>
                </Link>
            </div>
            <div className={`${styles.job__col} ${styles.job__quarter}`}>
                <p className={styles.job__department}>
                    {department?.label}
                </p>
            </div>
            <div className={`${styles.job__col} ${styles.job__quarter}`}>
                <p className={styles.job__location}>
                    {`${location?.city}${location?.region ? `, ${location?.region}` : location?.city === 'Birmingham' ? ', AL': ''}`}
                </p>
            </div>
        </div>
    );
}

export default Job;